// extracted by mini-css-extract-plugin
export default {"executeButton":"QueryInput_executeButton__ObEmQ","wrapper":"QueryInput_wrapper__5HMNL","input":"QueryInput_input__KfsrR","highlight":"QueryInput_highlight__BRC2s"};